import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { refreshTokenAction } from "../../Redux/actions/auth";
import toast from "react-hot-toast";

const Table = () => {
  const dispatch = useDispatch();
  const userFromStore = useSelector((state) => state.auth.user);
  const [user, setUser] = useState(
    userFromStore || JSON.parse(localStorage.getItem("user"))
  );
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = user?.token; // Token from user object

  // Handle token refresh
  const handleTokenRefresh = async (currentToken) => {
    console.log("Attempting to refresh token...");

    try {
      const response = await fetch(
        "https://backend.pmc-group.uk/api/refresh-token",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${currentToken}`,
          },
        }
      );

      if (!response.ok) {
        console.error("Token refresh failed. Status:", response.status);
        throw new Error("Failed to refresh token");
      }

      const data = await response.json();
      console.log("Token refreshed successfully:", data.newToken);

      const newToken = data.newToken;

      // Update token in state, store, and localStorage
      const updatedUser = { ...user, token: newToken };
      setUser(updatedUser);
      localStorage.setItem("user", JSON.stringify(updatedUser));
      dispatch(refreshTokenAction(newToken));

      return newToken;
    } catch (error) {
      console.error("Error refreshing token:", error);
      throw error;
    }
  };

  // Fetch requests for the user
  const fetchRequests = async (currentToken) => {
    console.log("Fetching requests with token:", currentToken);

    try {
      setLoading(true);
      setError(null);

      const response = await fetch("https://backend.pmc-group.uk/api/request", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${currentToken}`,
        },
      });

      console.log("Fetch response status:", response.status);

      if (!response.ok) {
        if (response.status === 401) {
          console.warn("Unauthorized. Attempting token refresh...");
          const newToken = await handleTokenRefresh(currentToken);
          return fetchRequests(newToken); // Retry with refreshed token
        }
        console.error("Error fetching requests. Status:", response.statusText);
        throw new Error(`Error fetching requests: ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Requests fetched successfully:", data);

      if (Array.isArray(data.data)) {
        console.log("Parsed requests data:", data.data);
        setRequests(data.data);
      } else {
        console.warn("Unexpected data format:", data);
        throw new Error("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching requests:", error);
      setError(error.message);
      toast.error("Failed to fetch requests.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      console.log("Token found. Initiating fetch...");
      fetchRequests(token);
    } else {
      console.warn("No token found. Cannot fetch requests.");
      setError("No token available. Please log in.");
    }
  }, [token]);

  if (loading) {
    return <div>Loading requests...</div>;
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  return (
    <div className="overflow-x-auto p-4">
      <table className="table-auto w-full border-collapse">
        <thead>
          <tr className="text-left font-bold bg-gray-200">
            <th className="px-4 py-2">Full Name</th>
            <th className="px-4 py-2">Phone</th>
            <th className="px-4 py-2">Postcode</th>
            <th className="px-4 py-2">Contact Time</th>
            <th className="px-4 py-2">Contact Date</th>
            <th className="px-4 py-2">Service Type</th>
            <th className="px-4 py-2">Description</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((request, index) => (
            <tr key={index} className="border-t">
              <td className="px-4 py-2">{request.full_name || "N/A"}</td>
              <td className="px-4 py-2">{request.phone_number || "N/A"}</td>
              <td className="px-4 py-2">{request.post_code || "N/A"}</td>
              <td className="px-4 py-2">{request.contact_time || "N/A"}</td>
              <td className="px-4 py-2">
                {new Date(request.contact_date).toLocaleDateString() || "N/A"}
              </td>
              <td className="px-4 py-2">
                {request.service_type?.name || "N/A"}
              </td>
              <td className="px-4 py-2">{request.description || "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
